import { Routes } from '@angular/router';

export const PRIVACY_POLICY_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './pages/privacy-policy-index/privacy-policy-index.component'
          ).then((x) => x.PrivacyPolicyIndexComponent),
      },
    ],
  },
];
